import img1 from "../Images/EventManagement-1030x611.jpg"
import img2 from "../Images/New-Age-Wedding-Planning.jpg"
import img3 from "../Images/EniNelly17-Powede-Lawrence-Ikenna-Traditional-BellaNaija-Weddings-George-Okoro3-.jpg"
import img4 from "../Images/NJ-Ugo-BellaNaija-Weddings-30-1080x720.jpg"
import img5 from "../Images/20121208-125839_150-ppi.jpg"
import img6 from "../Images/istockphoto-638647058-612x612.jpg"
import img7 from "../Images/istockphoto-522549410-612x612.jpg"
import img8 from "../Images/african-american-black-doctor-man.jpg"
import img9 from "../Images/venue-decoration-service-500x500.jpg"
import img10 from "../Images/JoAnn.jpg"
import img11 from "../Images/Mary-Marlon-White-Wedding-Enitan-Photography-UK-Wedding-BellaNaija-2016-232.jpg"
import img12 from "../Images/tele-consultation-covid-19-patients.jpg"
import img13 from "../Images/Tiwa-Jide-TeegotStunned-Prewedding-BellaNaija-Weddings.16.jpg"
import img14 from "../Images/cafe8b7703daff253a0b1fb67e1cfa48.png"
import img15 from "../Images/wedding venue decoration ideas.jpg"


const ImagesData =[
    {
        id:1,
        title: "my picture",
        url:`${img1}`,
        tags: ["event", "decoration"],
    },
    {
        id:2,
        title: "my picture",
        url:`${img2}`,
        tags: ["event", "wedding"],
    },
    {
        id:3,
        title: "my picture",
        url:`${img3}`,
        tags: ["event", "couple"],
    },
    {
        id:4,
        title: "my picture",
        url:`${img4}`,
        tags: ["event", "wedding"],
    },
    {
        id:5,
        title: "my picture",
        url:`${img5}`,
        tags: ["event", "decoration"],
    },
    {
        id:6,
        title: "my picture",
        url:`${img6}`,
        tags: ["event", "medical"],
    },
    {
        id:7,
        title: "my picture",
        url:`${img7}`,
        tags: ["event", "medical"],
    },
    {
        id:8,
        title: "my picture",
        url:`${img8}`,
        tags: ["event", "medical"],

    },
    {
        id:9,
        title: "my picture",
        url:`${img9}`,
        tags: ["event", "decoration"],
    },
    {
        id:10,
        title: "my picture",
        url:`${img10}`,
        tags: ["event", "couple"],
    },
    {
        id:11,
        title: "my picture",
        url:`${img11}`,
        tags: ["event", "wedding"],
    },
    {
        id:12,
        title: "my picture",
        url:`${img12}`,
        tags: ["event", "tech"],
    },
    {
        id:13,
        title: "my picture",
        url:`${img13}`,
        tags: ["event", "couple"],
    },
    {
        id:14,
        title: "my picture",
        url:`${img14}`,
        tags: ["event", "tech"],
    },
    {
        id:15,
        title: "my picture",
        url:`${img15}`,
        tags: ["event", "decoration"],
    }

]

export default ImagesData;
